import React, {useState, useEffect} from 'react';
import { BookedTCAService, DigitalTriageService, ImmediateTCAService,
    MedicalReferralService } from './ServiceConst';

const avivaClientID = 349910;

const InformationList = ({ clientID }) => {

    const userIDISAvivaClintID = (clientID === avivaClientID);

    return userIDISAvivaClintID ?
    <ul>
        <li>Informed the member that Digital Rehab should only be used for one injury or area of pain/discomfort</li>
        <li>
            Informed the member that the Digital Assessment does not work in older browsers including Internet Explorer
        </li>
        <li>Informed the member that the link for Digital Rehab will expire after 14 days</li>
    </ul>
    :
    <ul>
        <li>Informed the member that Digital Rehab should only be used for one injury or area of pain/discomfort</li>
        <li>Advised the member of any relevant T&C’s including excess or limits</li>
        <li>
            Advised the member that if they require F2F or Virtual Physio at the end of the Digital Assessment that they will be asked to authenticate payment card details
            (NB: This is the last opportunity to remind the member of their excess should Physiotherapy be recommended at the end of the Digital Assessment)
        </li>
        <li>
            Informed the member that the Digital Assessment does not work in older browsers including Internet Explorer
        </li>
        <li>Informed the member that the link for Digital Rehab will expire after 14 days</li>
    </ul>
}

// A single declaration the user has to tick. Always mandatory - a declaration
// is only rendered at all for services that require one.
const Declaration = ({containerID, id, label, ticked, setTicked, children}) => (
    <div id={containerID}>
        <div className="form__field">
            <div>
                <label htmlFor={id} className="referralFormCheckBoxLabel">{label}*</label>
            </div>
            <div className="referralFormCheckBox">
                <input
                    id={id}
                    type="checkbox"
                    required
                    style={{cursor: "pointer"}}
                    checked={ticked}
                    onChange={(e) => setTicked(e.target.checked)}
                />
            </div>
        </div>
        {children}
    </div>
)

/**
 * The declaration the user must tick before a referral can be confirmed.
 *
 * AB#2977: every service asks the user to confirm something different, so a
 * tick is only ever meaningful for the service that was selected when it was
 * made. ReferralForm remounts this component whenever the service changes
 * (key={service}), which drops the tick and makes the user confirm the new
 * statement - that is why one `ticked` value is enough, rather than one per
 * service.
 *
 * Booked TCA and Med Referral Choose & Book show no declaration at all.
 */
const ConfirmCheckBox = ({service, setCheckBox, clientID}) => {

    const [ticked, setTicked] = useState(false);

    // Tell the parent whether the declaration is satisfied - it gates the
    // Confirm button. Booked TCA has nothing to declare, so it counts as
    // satisfied automatically. (Med Referral Choose & Book has nothing to
    // declare either; the parent exempts it from the check.)
    useEffect(()=>{
        setCheckBox(service === BookedTCAService || ticked);
    }, [service, ticked, setCheckBox])

    switch(service){
        case DigitalTriageService:
            return (
                <Declaration
                    containerID="case45"
                    id="checkbox-digital-triage"
                    label="Confirm text and/or email sent to member with digital link providing access to digital landing page"
                    ticked={ticked}
                    setTicked={setTicked}
                >
                    <div>
                        <p>
                            Before continuing, please confirm you have:
                        </p>

                        <InformationList clientID={clientID} />
                    </div>
                </Declaration>
            )
        case ImmediateTCAService:
            return (
                <Declaration
                    containerID="case46"
                    id="checkbox-immediate-tca"
                    label={`Confirm that member has been handed over for ${clientID !== avivaClientID ? 'immediate TCA' : 'warm transfer'}`}
                    ticked={ticked}
                    setTicked={setTicked}
                />
            )
        case MedicalReferralService:
            return (
                <Declaration
                    containerID="case47"
                    id="checkbox-medical-referral"
                    label="Confirm that member has been handed over to book Physio"
                    ticked={ticked}
                    setTicked={setTicked}
                />
            )
        default:
            return <></>
    }
}

export default ConfirmCheckBox;
